// extracted by mini-css-extract-plugin
module.exports = {"toggle-switcher-row":"toggle-switcher-row___1ukXe","toggle-switcher-column":"toggle-switcher-column___2E_E6","first":"first___L4xKr","last":"last___FTYrr"};